import { DataFetchWrapper, Page, PageLink } from "@tfg/ui"
import { useMemo } from "react"
import { useTranslation } from "react-i18next"
import { useParams } from "react-router-dom"

import { useGetOrganizationQuery } from "./hooks"

export const OrganizationDetailsWrapper = () => {
  const { t } = useTranslation("admin")

  const params = useParams()
  const organizationId = params.organizationId
    ? +params.organizationId
    : undefined

  const organizationQuery = useGetOrganizationQuery(organizationId)

  const pages = useMemo<PageLink[]>(
    () => [
      {
        label: t("tabs.general"),
        link: "general",
      },
      {
        label: t("tabs.invoices"),
        link: "invoices",
      },
    ],
    [t]
  )

  return (
    <DataFetchWrapper query={organizationQuery}>
      {({ data }) => <Page title={data.name} pages={pages} data={data} />}
    </DataFetchWrapper>
  )
}
